export * from './placement.type';
export * from './position';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/@swimlane/ngx-charts/release/common/tooltip/position/index.js
// module id = ../../../../@swimlane/ngx-charts/release/common/tooltip/position/index.js
// module chunks = 4